module.exports = __webpack_public_path__ + "img/gallery_active.d2f401b8.svg";